<template>
    <div class="results flex flex-col h-full gap-2">
        <AiGridRo
            ref="historyGridRef"
            :meta="meta"
            :showToolbar="true"
            :column-auto-width="false"
            :args="x_args"
            :showFilterPanel="false"
            :autoLoadData="false"
        >
            <template #valTemplate="{ data }">
                <div class="relative flex align-center w-full">
                    <div class="min-h-[16px] w-full">
                        {{ data.displayValue }}
                    </div>
                </div>
            </template>
        </AiGridRo>
    </div>
</template>

<script setup>
import { ref, inject, onMounted, watch } from 'vue';
import AiGridRo from '@/components/ai-grid-ro/ai-grid-ro.vue';

const historyGridRef = ref(null);

const x_args = ref(null);

// аргументы запроса
const search_args = inject('search_args');

// как они изменились - запуск нового поиска
watch(
    () => search_args,
    async search_args => {
        if (!search_args.params.first) {
            historyGridRef.value.refreshData(search_args.args);
        }
    },
    { deep: true }
);

const meta = {
    title: 'Произведенные изменения',
    keyExpr: 'id',
    showCheckBoxesMode: 'none',
    showFilterPanel: false,
    wordWrapEnabled: true,
    scrollingMode: 'standart',

    api: {
        select: 'core./history/get',
    },
    columns: [
        {
            dataField: 'id',
            caption: 'id',
            visible: false,
        },
        {
            dataField: 'dt',
            dataType: 'datetime',
            caption: 'Дата/Время',
        },
        {
            dataField: 'tab_name',
            caption: 'Таблица',
        },
        {
            dataField: 'col',
            caption: 'Где',
        },
        {
            dataField: 'old_value',
            caption: 'Было',
            cellTemplate: 'valTemplate',
        },
        {
            dataField: 'new_value',
            caption: 'Стало',
            cellTemplate: 'valTemplate',
        },
        {
            dataField: 'info',
            caption: 'Примечание',
        },
        {
            dataField: 'who',
            caption: 'Пользователь',
        },
        {
            dataField: 'dog_num',
            caption: 'Договор',
        },
        {
            dataField: 'dep_name',
            caption: 'Подразделение',
        },
        {
            dataField: 'obj_name',
            dataType: 'string',
            caption: 'Объект договора',
        },
        {
            dataField: 'pnt_num',
            caption: 'Точка учета',
        },
    ],
};

onMounted(() => {
});
</script>

<style lang="scss" scoped>
:deep(.dx-toolbar h3) {
    color: #999;
}
.results {
    margin-left: 32px;
    margin-right: 32px;
}
</style>
